import { render, staticRenderFns } from "./DSButton.vue?vue&type=template&id=00ebeb0a&scoped=true&"
import script from "./DSButton.vue?vue&type=script&lang=js&"
export * from "./DSButton.vue?vue&type=script&lang=js&"
import style0 from "./DSButton.vue?vue&type=style&index=0&id=00ebeb0a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ebeb0a",
  null
  
)

export default component.exports